import { Moon, Palette, Sun } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

type Theme = 'light' | 'dark' | 'sedec'

const OPTIONS: Array<{ value: Theme; key: string; icon: typeof Sun }> = [
  { value: 'light', key: 'light', icon: Sun },
  { value: 'dark', key: 'dark', icon: Moon },
  { value: 'sedec', key: 'sedec', icon: Palette },
]

function currentTheme(): Theme {
  const value = document.documentElement.dataset.theme
  return value === 'light' || value === 'dark' || value === 'sedec' ? value : 'sedec'
}

export function ThemeSwitcher() {
  const { t } = useTranslation()
  const [theme, setTheme] = useState<Theme>(currentTheme)

  useEffect(() => {
    document.documentElement.dataset.theme = theme
    localStorage.setItem('icpm-theme', theme)
  }, [theme])

  return (
    <div className="flex items-center gap-1 rounded-full border border-line bg-panel-2 p-1" aria-label={t('theme.label')}>
      {OPTIONS.map(({ value, key, icon: Icon }) => {
        const label = t(`theme.${key}`)
        return (
          <button
            key={value}
            type="button"
            className={`flex h-8 items-center gap-1.5 rounded-full px-2.5 text-xs font-semibold ${
              theme === value ? 'bg-panel text-ink shadow-sm' : 'text-ink-2 hover:text-ink'
            }`}
            aria-pressed={theme === value}
            onClick={() => setTheme(value)}
            title={t('theme.title', { theme: label })}
          >
            <Icon size={14} aria-hidden="true" />
            <span className="hidden sm:inline">{label}</span>
          </button>
        )
      })}
    </div>
  )
}
